export default __webpack_public_path__ + "static/logo-da4fdc96df5025f3288458595be79e09.png";